const PREVIEW_PATH = /^(.*\/terminal-preview\/[^/]+)(?:\/.*)?$/

export function appBasePath(pathname = window.location.pathname) {
  const preview = pathname.match(PREVIEW_PATH)
  if (preview) return `${preview[1]}/`
  const configured = import.meta.env.BASE_URL
  if (configured !== './' && configured !== '') return configured
  if (pathname.endsWith('/')) return pathname
  return pathname.slice(0, pathname.lastIndexOf('/') + 1) || '/'
}

export function publicAsset(value: string) {
  if (/^(?:[a-z][a-z\d+.-]*:|\/\/)/i.test(value)) return value
  return publicPath(value)
}

export function publicPath(value: string) {
  const path = value.replace(/^\/+/, '')
  return new URL(path, new URL(appBasePath(), window.location.href)).pathname
}
